import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    createCheckEFT: {
        method: 'POST',
        url: `${BASE_PATH_API}/checkefts`
    },
    getTwoFactorAuthenticationStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/checkefts/twoFactorAuthenticationStatus`
    },
    getEFT: {
        method: 'GET',
        url: `${BASE_PATH_API}/efts/:id`
    },
    getBillsForEFT: {
        method: 'GET',
        url: `${BASE_PATH_API}/efts/:id/bills`
    },
    updateEFT: {
        method: 'PUT',
        url: `${BASE_PATH_API}/efts/:id`
    },
    voidEFT: {
        method: 'POST',
        url: `${BASE_PATH_API}/checkefts/:id/void`
    },
    calculateApprovalStatus: {
        method: 'POST',
        url: `${BASE_PATH_API}/efts/calculateApprovalStatus`
    },
    getEftApprovers: {
        method: 'GET',
        url: `${BASE_PATH_API}/efts/approvers`
    }
};
export function CheckEftsApi() {
    return createActions(actions);
}
